//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import UserProfileService from '@/apps/data-platform/services/user_profile_service';
import ProjectsService from '@/apps/data-platform/services/master_data/projects_service';
import tasks from '@/js/tasks';
export default {
  name: 'TabConnectionView',
  props: {
    item: {
      type: Object,
      default: null
    },
    readonly: {
      type: Boolean,
      default: false
    },
    isChangeRequest: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      filtro: '',
      new_table: {},
      projectListDict: [],
      key_table: 0
    };
  },
  computed: {
    headers: function headers() {
      return [{
        value: 'project_name',
        text: this.traductor('my_tasks.modals.project'),
        class: 'w-15'
      }, {
        value: 'dataset_name',
        text: this.traductor('my_tasks.tablas_tasks.dataset'),
        class: 'w-5'
      }, {
        value: 'table_name',
        text: this.traductor('my_tasks.tablas_tasks.table'),
        class: 'w-10'
      }, {
        value: 'actions',
        text: this.traductor('my_tasks.tablas_tasks.actions'),
        class: 'w-5'
      }];
    },
    texts: function texts() {
      return {
        project: this.traductor('frases.project'),
        table: this.traductor('frases.table')
      };
    }
  },
  created: function created() {
    this.getProjects();
  },
  methods: {
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    getProjects: function getProjects() {
      var _this = this;
      ProjectsService.getAllProjects().then(function (response) {
        if (response.code = 200 && response.success) {
          _this.domainList = response.data.domains;
          _this.projectListDict = [];
          response.data.projects[window.userInfo.domain].forEach(function (x) {
            _this.projectListDict.push({
              "value": x,
              "text": x
            });
          });
        }
      }, function (err) {
        console.log(err);
      });
    },
    valid: function valid() {
      var _this2 = this;
      if (!this.new_table.project_name) {
        tasks.toast.error("Set the project name!");
        //this.$toast.warning("Set the project name!")
        return false;
      }
      if (!this.new_table.dataset_name) {
        tasks.toast.error("Set the dataset name!");
        //this.$toast.warning("Set the dataset name!")
        return false;
      }
      if (!this.new_table.table_name) {
        tasks.toast.error("Set the table name!");
        //this.$toast.warning("Set the table name!")
        return false;
      }
      var finds = this.item.tables.filter(function (x) {
        return x.project_name == _this2.new_table.project_name && x.dataset_name == _this2.new_table.dataset_name && x.table_name == _this2.new_table.table_name;
      });
      if (finds.length > 0) {
        tasks.toast.error("The table was selected already!");
        //this.$toast.warning("The table was selected already!")
        return false;
      }
      return true;
    },
    odAddTable: function odAddTable() {
      var _this3 = this;
      if (!this.valid()) {
        return;
      }
      var defaultParams = {
        values: {
          project_name: this.new_table.project_name,
          dataset_name: this.new_table.dataset_name,
          table_name: this.new_table.table_name,
          source: 'bigquery'
        }
      };
      UserProfileService.validateTable(defaultParams).then(function (response) {
        if (response.code == 200 && response.success && response.data && response.data.id) {
          var new_data = {
            "datasource_id": _this3.kdatasource,
            project_name: _this3.new_table.project_name,
            dataset_name: _this3.new_table.dataset_name,
            table_name: _this3.new_table.table_name,
            type: response.data.type
          };
          _this3.item.tables.push(new_data);
          _this3.key_table += 1;
          _this3.resetForm();
        } else {
          tasks.toast.error("The table or view does not exists or it is not in 'prod' enviroment yet.");
          //this.$toast.warning("The table or view does not exists or it is not in 'prod' enviroment yet.")
        }
      });
    },
    deleteItem: function deleteItem(table) {
      var index = this.item.tables.indexOf(table);
      if (index != -1) {
        this.item.tables.splice(index, 1);
      }
      this.key_table += 1;
    },
    resetForm: function resetForm() {
      this.new_table = {};
      this.kdatasource = '';
    },
    onShowTable: function onShowTable(item) {
      this.$emit('onShowTable', item);
    }
  }
};